import React, {Fragment} from "react";
import {withRouter} from "./Utils";
import {Link, Params} from "react-router-dom";
import "./Platform.css";
import config, { getApiUrl } from "./config";
import authService from "./AuthService";

type HalComponent = {
    id: number
    friendlyName: string
    imageReference: string
    version: string
}

type PlatformDetails = {
    name: string
    friendlyName: string
    manufacturer: string
    manufacturerURL: string
    model: string
    modelURL: string
    description: string
    halComponents: Array<HalComponent>
}

type PlatformProperties = {
    params?: Readonly<Params>
}

type PlatformState = {
    name: string
    details: PlatformDetails | undefined
}

class Platform extends React.Component<PlatformProperties, PlatformState> {
    constructor(props: PlatformProperties) {
        super(props);
        this.state = {
            name: props.params!["name"] || "",
            details: undefined
        }
        this.fetchDetails();
    }

    private fetchDetails() {
        fetch(getApiUrl() + "/v1/component/platform/" + this.state.name, {
            headers: [
                ["Accept", "application/json"],
                ["Authorization", authService.authHeader()]
            ]
        })
            .then(response => response.json() as Promise<PlatformDetails>)
            .then((response) => {
                this.setState({
                    details: response
                })
            })
            .catch((error) => {
                console.error(error);
            });
    }

    render() {
        return (
            <div className="Platform">
                <h2>{this.state.details?.friendlyName || this.state.name}</h2>
                <h3>Details:</h3>
                {this.renderDetails()}
                <h3>HAL Components:</h3>
                {this.renderHalComponents()}
            </div>
        );
    }

    private renderDetails() {
        if (this.state.details !== undefined) {
            return (
                <Fragment>
                    <div className="Platform-description">
                        {this.state.details.description}
                    </div>
                    <div className="Platform-details">
                        <div className="Platform-detail-label">Platform name</div>
                        <div className="Platform-detail-value">{this.state.details.name}</div>
                        <div className="Platform-detail-label">Model</div>
                        <div className="Platform-detail-value">
                            <a href={this.state.details.modelURL} target="_blank">{this.state.details.model}</a>
                        </div>
                        <div className="Platform-detail-label">Manufacturer</div>
                        <div className="Platform-detail-value">
                            <a href={this.state.details.manufacturerURL} target="_blank">{this.state.details.manufacturer}</a>
                        </div>
                    </div>
                </Fragment>
            );
        } else {
            return <div>Loading...</div>;
        }
    }

    private renderHalComponents() {
        if (this.state.details !== undefined) {
            return (
                <div className="Platform-halComponents">
                    {this.state.details.halComponents.map((component) => {
                        return (
                            <Link to={"/component/platform/hal/" + component.id}
                                  className="Platform-halComponent" key={component.id}>
                                {component.friendlyName}<small
                                className="Platforms-model">Image: <strong>{component.imageReference}:{component.version}</strong></small>
                            </Link>
                        );
                    })}
                </div>
            );
        } else {
            return <div>Loading...</div>;
        }
    }
}

const HOCPlatform = withRouter(Platform);
export default HOCPlatform;